import { Flex, HStack, Text, VStack } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import Layout from "../../../components/dashboard/Layout";
import LogoutMenu from "../../../components/dashboard/Layout/logout-menu";
import EnrollCourseRequestsTable from "../../../containers/superadmin/enrollCourses/table";
import {
  getAllCoursesRequest,
  getAllEnrollCourseRequest,
} from "../../../modules/superadmin-modules/courses/Actions";

const SuperadminEnrollCourseRequests = () => {
  const dispatch = useDispatch();
  const [courseId, setCourseId] = useState(null);
  const { enrollCoursesCount } = useSelector((state) => state.courses);
  const courses = useSelector((state) => state.courses.courses);

  const coursesOptions = courses?.map((data) => {
    return { value: data.id, label: data.name };
  });
  useEffect(() => {
    if (courseId) dispatch(getAllEnrollCourseRequest(courseId));
  }, [courseId]);

  const colourStyles = {
    control: (styles) => ({
      ...styles,
      width: "100%",
      background: "white",
      color: "#690000",
      borderRadius: "16px",
      position: "relative",
      zIndex: 999,
    }),
    option: (styles) => ({
      ...styles,
      color: "#690000",
      position: "relative",
      zIndex: 999,
    }),
  };

  useEffect(() => {
    dispatch(getAllCoursesRequest());
  }, []);
  return (
    <Layout>
      <VStack w="100%" py="30px">
        <Flex alignItems="center" w="100%" justifyContent="space-between">
          <Text fontSize="24px" fontWeight="600" color="main_1">
            الطلبات
          </Text>

          <Flex alignItems="center">
            <LogoutMenu />
          </Flex>
        </Flex>

        <Text w="100%" fontSize="20px" textAlign="right">
          عدد الطلبات :{enrollCoursesCount}
        </Text>
        <HStack
          w="100%"
          justifyContent="space-between"
          bg="#f5f5f5"
          mt="40px !important"
          p="10px"
          mb="-30px !important"
        >
          <HStack spacing="5px">
            <Select
              options={coursesOptions}
              onChange={(data) => setCourseId(data?.value)}
              styles={colourStyles}
              placeholder="الدورات"
              isClearable
            />
          </HStack>
        </HStack>
      </VStack>
      <EnrollCourseRequestsTable courseId={courseId} />
    </Layout>
  );
};

export default SuperadminEnrollCourseRequests;
